import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {IconButton} from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
// import i18next from 'i18next';
import { useTranslation } from 'react-i18next';


// ------------------------------- LANGUAGES -------------------------------
// const langs = ['Arabic', 'Chinese(Simplified)', 'Chinese(Traditional)', 'English', 'French', 'German', 'Hindi', 'Japanese', 'Korean', 'Russian', 'Spanish', 'Swahili', 'Swedish', 'Vietnamese']
const LANGS = [
  { code: 'ar', label: 'Arabic' },
    { code: 'zh', label: 'Chinese (Simplified)' },
    { code: 'zh-Hant', label: 'Chinese (Traditional)' },
    { code: 'en', label: 'English' },
    { code: 'fr', label: 'French' },
    { code: 'de', label: 'German' },
    { code: 'hi', label: 'Hindi' },
    { code: 'ja', label: 'Japanese' },
    { code: 'ko', label: 'Korean' },
    { code: 'ru', label: 'Russian' },
    { code: 'es', label: 'Spanish' },
    { code: 'sw', label: 'Swahili' }, 
    { code: 'sv', label: 'Swedish' },
    { code: 'vi', label: 'Vietnamese' }
];
// ------------------------------- LANGUAGES -------------------------------

const SimpleMenu = () => {
    const { i18n } = useTranslation();

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const changeLang = (lang) => {
        i18n.changeLanguage(lang);
        setAnchorEl(null);
    }

    // Fallback to 'en' just in case the language hasn't loaded yet
    const currentLang = i18n.language || 'en';

    return (
        <>
            <IconButton aria-controls="simple-menu" onClick={handleClick}>
                <TranslateIcon/>
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {LANGS.map((lang) => {
                    // Check if this specific menu item is the currently active language
                    const isActive = currentLang === lang.code; 
                    
                    return (
                        <MenuItem 
                            key={lang.code} 
                            onClick={() => changeLang(lang.code)}
                            // Apply conditional Material-UI styling based on isActive
                            sx={{
                                backgroundColor: isActive ? '#E8DEF8' : 'transparent',
                                color: isActive ? '#6750A4' : 'inherit',
                                fontWeight: isActive ? 600 : 400,
                                '&:hover': {
                                    backgroundColor: isActive ? '#E8DEF8' : 'rgba(0, 0, 0, 0.04)',
                                }
                            }}
                        >
                            {lang.label}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
}

export default SimpleMenu 
